import React from "react";

const VideoPlayer = ({ url }) => {
  return (
    <video width="80%" height="80%" controls autoPlay>
      <source src={url} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export default VideoPlayer;
